export const defaultStoreImports = {
  state: ['query'],
  getters: [],
  actions: ['fetchList'],
  mutations: ['setPage', 'setQuery'],
  getters: ['loading', 'params'],
}

export default {
  data() {
    return { q: {}, enabledFilters: [] }
  },
  methods: {
    setEnabledFilters(filters) {
      this.enabledFilters = filters
    },
    onFilter() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
    isEnabledFilter(filterName) {
      return this.enabledFilters.includes(filterName)
    },
  },
  created() {
    this.$set(this, 'q', { ...this.q, ...this.query })
  },
}
